import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO11 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK001-1.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO11
